import { FadeUp } from "@/components/site/Reveal";
import { MEDIA } from "@/lib/assets";
import { Ship, Warehouse, Truck, Scissors } from "lucide-react";

const STEPS = [
  { icon: Ship, title: "Global Sourcing", body: "Authorised dealer relationships with leading domestic & international paper mills." },
  { icon: Scissors, title: "Quick Sheet Cutting", body: "In-house sheet-cutting centres in Bhiwandi & Ahmedabad for made-to-size delivery." },
  { icon: Warehouse, title: "Strategic Stocking", body: "Buffer stock held close to West-zone manufacturing hubs to cut lead times." },
  { icon: Truck, title: "Pan-India Delivery", body: "Tracked distribution to production lines right across India, on schedule." },
];

const STATS = [
  { value: "4000T", label: "Monthly sheeting capacity" },
  { value: "5", label: "Stocking warehouses" },
  { value: "2", label: "Sheet-cutting centres" },
  { value: "Pan-India", label: "Distribution reach" },
];

export const SupplyChain = () => {
  return (
    <section id="supply" data-testid="supply-section" className="bg-foreground text-background py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <FadeUp>
              <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-primary mb-6">/ Capabilities</p>
              <h2 className="font-display text-5xl md:text-7xl leading-[0.95]">
                From mill to your factory floor.
              </h2>
              <p className="text-background/70 mt-8 max-w-md leading-relaxed">
                As authorised dealers and quick sheet-cutting specialists, we run cutting centres in Bhiwandi
                (Maharashtra) and Ahmedabad (Gujarat) — supplying the right grade, cut to size, right across India.
              </p>
            </FadeUp>

            <div className="mt-14 grid sm:grid-cols-2 gap-x-8 gap-y-10">
              {STEPS.map((s, i) => (
                <FadeUp key={s.title} delay={i * 0.08}>
                  <div className="flex gap-4" data-testid={`supply-step-${i}`}>
                    <s.icon size={28} className="text-primary shrink-0 mt-1" strokeWidth={1.5} />
                    <div>
                      <h3 className="font-display text-xl mb-2">{s.title}</h3>
                      <p className="text-sm text-background/60 leading-relaxed">{s.body}</p>
                    </div>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>

          <FadeUp delay={0.15} className="h-full">
            <div className="relative">
              <div className="overflow-hidden border border-background/15">
                <img src={MEDIA.qscFacility} alt="Quick sheet cutting facility" className="w-full h-[520px] object-cover" />
              </div>
            </div>
          </FadeUp>
        </div>

        <div className="mt-24 grid grid-cols-2 md:grid-cols-4 border-t border-background/15">
          {STATS.map((s, i) => (
            <FadeUp key={s.label} delay={i * 0.08}>
              <div className="py-10 md:border-r border-background/15 px-2" data-testid={`stat-${i}`}>
                <div className="font-display text-5xl md:text-6xl text-primary">{s.value}</div>
                <div className="font-mono2 text-[11px] uppercase tracking-[0.2em] text-background/60 mt-3">{s.label}</div>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
